/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Payment_Qr_WaitingInputs */

const vi_payment_qr_waiting = /** @type {(inputs: Payment_Qr_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang chờ thanh toán...`)
};

/**

* @param {Payment_Qr_WaitingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const payment_qr_waiting = /** @type {((inputs?: Payment_Qr_WaitingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Payment_Qr_WaitingInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_payment_qr_waiting(inputs)
});